import React from 'react';
import {BackgroundVideoOptionsArray} from '../../../types';
import {RatioKeptVideo} from '../video/RatioKeptVideo';
import {UeLightbox} from './UeLightbox';
import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';
import {isValidMediaOptions} from '../../../utils';

const Styled = styled.div`
    .lightbox-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;
export interface VideoLightboxProps {
    mediaOptions?: BackgroundVideoOptionsArray;
    isOpen?: boolean;
    toggleLightbox: (e?: any) => void;
    accentColor?: AccentColorOptions;
}

export const VideoLightbox = ({
    mediaOptions = [],
    isOpen = false,
    toggleLightbox
}: VideoLightboxProps): JSX.Element | null => {
    if (!isValidMediaOptions(mediaOptions)) return null;

    return (
        <Styled className="video-lightbox">
            <UeLightbox isOpen={isOpen} onClick={toggleLightbox}>
                <RatioKeptVideo mediaOptions={mediaOptions} />
            </UeLightbox>
        </Styled>
    );
};
